/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryNextGenReportType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryNextGenReportType");
    }

    getFixupPrototypeFunction() { return ScheduleQueryNextGenReportType.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryNextGenReportType>): ScheduleQueryNextGenReportType {
        let obj = Object.assign(new ScheduleQueryNextGenReportType(), model);
        ScheduleQueryNextGenReportType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryNextGenReportType>): ScheduleQueryNextGenReportType {
        if (!model) return null;
        return ScheduleQueryNextGenReportType.newInstance(<ScheduleQueryNextGenReportType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryNextGenReportType) {
        if (!obj) return;

        models.ScheduleQueryNextGenReportType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryNextGenReportType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryNextGenReportType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * NextGen Report Type of the Schedule for category reports
     */
    nextgen_report_types: Array<models.NextGenReportType>;

}
